import { MainHeader, Section, SectionParagraph } from '@/components/shared/Content';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import topFoldImgDefMobile from '@/static/claims/lemonade-claims-page-main-image-mobile.png';
import topFoldImgDefDesktop from '@/static/claims/lemonade-claims-page-main-image.png';
import topFoldImgRedMobile from '@/static/claims/reddish/lemonade-claims-page-main-image-mobile.png';
import topFoldImgRedDesktop from '@/static/claims/reddish/lemonade-claims-page-main-image.png';
import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import type React from 'react';
import styled, { useTheme } from 'styled-components';

const images = {
  pinkish: {
    desktop: topFoldImgDefDesktop,
    mobile: topFoldImgDefMobile,
  },
  reddish: {
    desktop: topFoldImgRedDesktop,
    mobile: topFoldImgRedMobile,
  },
} as Record<string, { desktop: StaticImageData; mobile: StaticImageData }>;

const TopFoldSection = styled(Section)`
  min-height: 715px;
  position: relative;

  ${MEDIA_QUERIES.desktop`
        min-height: 705px;
    `}
`;

const ContentWrapper = styled(Flex)`
  max-width: 800px;
  width: 100%;

  ${MEDIA_QUERIES.tabletAndDesktop`
        padding: 60px 0 20px;
    `}
`;

const TopFoldParagraph = styled(SectionParagraph)`
  padding-top: 20px;
  max-width: 365px;
  z-index: 1;
  ${font('main', { fontSize: '2rem', lineHeight: '3.0rem' })}

  ${MEDIA_QUERIES.tabletAndDesktop`
        white-space: pre-line;
    `}
`;

const TopFoldImage = styled(Image)`
  display: block;
  position: relative;
  bottom: 0;
  right: 0;
`;

const MobileFoldImage = styled(TopFoldImage)`
  display: inline-block;

  ${MEDIA_QUERIES.tabletAndDesktop`
        display: none;
    `}
`;

const DesktopFoldImage = styled(TopFoldImage)`
  display: none;
  position: absolute;
  bottom: 0;
  right: calc(50% - 661.5px);

  ${MEDIA_QUERIES.tabletAndDesktop`
        display: inline-block;
    `}
`;

export interface HeroProps {
  title: string;
  subtitle: string;
}

export const Hero: React.FC<HeroProps> = ({ title, subtitle }) => {
  const { name } = useTheme();
  useShowHeaderCtaOnScroll(true);

  return (
    <TopFoldSection as="section" mt={[0, 36]}>
      <ContentWrapper alignItems="center" flexDirection="column" pt={40}>
        <MainHeader tabIndex={0}>{title}</MainHeader>
        <TopFoldParagraph tabIndex={0}>{subtitle}</TopFoldParagraph>
        <MobileFoldImage src={images[name].mobile} alt="" layout="responsive" />
        <DesktopFoldImage src={images[name].desktop} width={1324} height={499} alt="" priority />
      </ContentWrapper>
    </TopFoldSection>
  );
};
